/**
 * ArchiveButton
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import useDialog from 'containers/Dialog/useDialog.js';
import messages from './messages.js';
import useArchive from '../useArchive.js';

function ArchiveButton(props) {
  const { group } = props;
  const { dlgClick } = useDialog();
  const { handleArchive } = useArchive(group);

  const confirmedHandler = () => dlgClick({
    message: { ...messages.confirmArchive, values: group },
    confirmLabel: messages.doArchive,
    confirmStyle: 'danger',
  }, handleArchive);

  return (
    <Button
      variant="light"
      className="text-danger"
      onClick={confirmedHandler}
    >
      <FormattedMessage {...messages.archiveGroup} />
    </Button>
  );
}

ArchiveButton.propTypes = {
  group: PropTypes.object,
};

export default ArchiveButton;
